var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1005,
    height: 178,
    viewBox: "0 0 1005 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 145.43C71 145.43 71 155.116 186.315 111.41C246.053 88.7686 280.789 43.1215 353.352 43.3714C429.254 43.6329 449.21 105.489 522.934 95.5656C594.311 85.9581 559.531 20.9898 630.617 10.7501C726.446 -3.05364 707.226 108.352 806.134 111.41C915.312 114.786 1002 1.42969 1002 1.42969",
    stroke: "white",
    strokeWidth: 1,
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 155.93C2 155.93 123.207 56.083 192.801 46.2005C274.499 34.5992 300.475 113.197 382.638 102.619C464.498 92.0813 422.265 6.30862 506.372 6.42982C570.62 6.52239 570.106 63.5293 634.342 62.8487C678.744 62.3783 691.301 37.864 735.194 34.1768C825.21 26.6149 851.31 125.865 931.811 102.619C981.593 88.2444 1003 34.1768 1003 34.1768",
    stroke: "#2f80ED",
    strokeOpacity: 1,
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.57d46689292cc4fd59f37b6bcce2b5f3.svg";
export { ForwardRef as ReactComponent };